import { Card } from "../general/card";
import { Metric } from "../general/custom";
import { Box } from "@mui/material";
import Loader from "../general/loader";
import { formatEnergy } from "../../scripts/utils";

export default function SolarInfo({ data, isFetching }) {
  const totalProduction = data?.total_production ? Number(data.total_production.toFixed(2)) : null;
  const curtailedProduction = data?.curtailed_production ? Number(data.curtailed_production.toFixed(2)) : null;
  const injectedProduction = data?.injected_production ? Number(data.injected_production.toFixed(2)) : null;
  const usedProduction = data?.consumed_production ? Number(data.consumed_production.toFixed(2)) : null;

  return (
    <Card display="flex" flexDirection="column" justifyContent="center" alignItems="center" title="Solar Statistics">
      {isFetching ? (
        <Loader />
      ) : (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            rowGap: 1,
            columnGap: { xs: 0, sm: 1 },
          }}
        >
          <Metric name="Total Production" value={formatEnergy(totalProduction)} width={{ xs: 120, sm: 170, md: 200 }} />
          <Metric
            name="Curtailed Production"
            value={formatEnergy(curtailedProduction)}
            width={{ xs: 120, sm: 170, md: 200 }}
          />
          <Metric
            name="Injected Production"
            value={formatEnergy(injectedProduction)}
            width={{ xs: 120, sm: 170, md: 200 }}
          />
          <Metric
            name="Consumed Production"
            value={formatEnergy(usedProduction)}
            width={{ xs: 120, sm: 170, md: 200 }}
          />
        </Box>
      )}
    </Card>
  );
}
